module.exports = __webpack_public_path__ + "static/media/CABLE.cf998db6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/CABLE.svg
// module id = 388
// module chunks = 25